module.exports = __webpack_public_path__ + "img/6.f7f3a7c3.png";